<script setup>

import {Link, usePage} from "@inertiajs/vue3";
import RouteUserAvatar from "@/Components/documents/route/RouteUserAvatar.vue";
import {computed} from "vue";

const props = defineProps({
    notification: {
        type: Object,
        required: true
    },
    avatarStatus: {
        type: String,
        default: ''
    }
});

const genericDocument = computed(() => props.notification.data.document || props.notification.data.external_document);

const getUserName = (user) => {
    if (user.id === usePage().props.auth.user.id) {
        return 'Вы ';
    }
    return `${user.name} ${user.last_name} `;
};

const routeName = computed(() => {
    if (!usePage().props.external_edo_enabled) {
        return 'documents.show';
    }

    return props.notification.data.external_document ? 'external.documents.show' : 'documents.show';
});
</script>

<template>
    <div class="flex gap-5 items-center">
        <RouteUserAvatar :status="avatarStatus"
                         :users="[notification.data.user]"
                         create-link
                         size="md"/>
        <div class="flex flex-col text-sm">
            <p>
                <component :is="notification.data.user.permissions?.view ? Link : 'span'"
                           :href="route('users.show', notification.data.user.id)"
                           class="font-semibold">
                    {{ getUserName(notification.data.user) }}
                </component>
                <slot name="info-text"/>
            </p>
            <p class="text-accent-blue flex gap-2 items-center">
                <span>{{ notification.created_at }}</span>
                <span class="text-accent-blue text-base">•</span>
                <Link v-if="genericDocument"
                      :href="route(routeName, genericDocument.id)"
                      class="underline font-semibold">
                    {{ genericDocument.name }}
                </Link>
                <span v-else
                      class="font-semibold">Документ удален</span>
            </p>
        </div>
    </div>
</template>
